import { matchPath } from 'react-router-dom';

// Routes that own their whole viewport (kanban boards, embedded apps, split
// layouts): MainLayout drops the footer and bottom padding for them. One list
// instead of a growing chain of pathname booleans — add a pattern here when a
// new full-bleed screen ships. `*` suffix matches nested paths.
const FULL_BLEED_PATTERNS = [
  '/booking/meeting-room',
  '/doc-search',
  '/doc-chatbot',
  '/hr',
  '/payment-requests/*',
  '/drives/list',
  '/drives/trash/list',
  '/drives/:id'
];

export const isFullBleedPath = pathname => {
  if (pathname.includes('kanban')) return true;
  return FULL_BLEED_PATTERNS.some(pattern => matchPath(pattern, pathname));
};
